// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventAssociationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ChangeEventFilter>;
}>;


export type ChangeEventAssociationsQuery = { __typename?: 'Query', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, homeownerContractChangeOrder?: { __typename?: 'HomeownerContractChangeOrder', id: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, priceChangeInCents: number, title: string } | null | undefined, estimates: Array<{ __typename?: 'Estimate', id: string, createdAt: Types.Scalars['DateTime']['input'], totalPriceInCents: number, title: string, status: { __typename?: 'EstimateStatusDetail', code: Types.EstimateStatus, name: string }, type: { __typename?: 'EstimateTypeDetail', code: Types.EstimateType, name: string } }> }> };

export type ChangeEventChangeOrderFragment = { __typename?: 'HomeownerContractChangeOrder', id: string, executionDate?: Types.Scalars['Date']['input'] | null | undefined, priceChangeInCents: number, title: string };

export type ChangeEventEstimateFragment = { __typename?: 'Estimate', id: string, createdAt: Types.Scalars['DateTime']['input'], totalPriceInCents: number, title: string, status: { __typename?: 'EstimateStatusDetail', code: Types.EstimateStatus, name: string }, type: { __typename?: 'EstimateTypeDetail', code: Types.EstimateType, name: string } };

export const ChangeEventChangeOrderFragmentDoc = gql`
    fragment ChangeEventChangeOrder on HomeownerContractChangeOrder {
  id
  executionDate
  priceChangeInCents
  title
}
    `;
export const ChangeEventEstimateFragmentDoc = gql`
    fragment ChangeEventEstimate on Estimate {
  id
  createdAt
  totalPriceInCents
  title
  status {
    code
    name
  }
  type {
    code
    name
  }
}
    `;
export const ChangeEventAssociationsDocument = gql`
    query ChangeEventAssociations($filter: ChangeEventFilter) {
  changeEvents(filter: $filter) {
    id
    homeownerContractChangeOrder {
      ...ChangeEventChangeOrder
    }
    estimates {
      ...ChangeEventEstimate
    }
  }
}
    ${ChangeEventChangeOrderFragmentDoc}
${ChangeEventEstimateFragmentDoc}`;

/**
 * __useChangeEventAssociationsQuery__
 *
 * To run a query within a React component, call `useChangeEventAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventAssociationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChangeEventAssociationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>(ChangeEventAssociationsDocument, options);
      }
export function useChangeEventAssociationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>(ChangeEventAssociationsDocument, options);
        }
// @ts-ignore
export function useChangeEventAssociationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>;
export function useChangeEventAssociationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventAssociationsQuery | undefined, ChangeEventAssociationsQueryVariables>;
export function useChangeEventAssociationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>(ChangeEventAssociationsDocument, options);
        }
export type ChangeEventAssociationsQueryHookResult = ReturnType<typeof useChangeEventAssociationsQuery>;
export type ChangeEventAssociationsLazyQueryHookResult = ReturnType<typeof useChangeEventAssociationsLazyQuery>;
export type ChangeEventAssociationsSuspenseQueryHookResult = ReturnType<typeof useChangeEventAssociationsSuspenseQuery>;
export type ChangeEventAssociationsQueryResult = ApolloReactCommon.QueryResult<ChangeEventAssociationsQuery, ChangeEventAssociationsQueryVariables>;